export default __webpack_public_path__ + "static/media/navigation-rail-specs.9b21c644.png";